import { Button, Modal } from "@/components";
import styles from "./DeleteBrandModal.module.scss";

type DeleteBrandModalProps = {
  isOpen: boolean;
  brandName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const DeleteBrandModal = ({
  isOpen,
  brandName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteBrandModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={isDeleting ? () => {} : onClose}>
      <div className={styles["comp"]}>
        <div>
          <div className={styles["comp__heading"]}>Delete branding?</div>
          <p className={styles["comp__description"]}>
            This branding package will be removed. Devices using it may need to be reassigned.
          </p>
          <div className={styles["comp__fileName"]} title={brandName}>
            „{brandName}”
          </div>
        </div>

        <div className={styles["comp__actions"]}>
          <Button type="button" variant="secondary" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
